const scrollLock = require("body-scroll-lock");

module.exports = class {

    constructor(element) {

        this.element = element;
        this.overlay = document.querySelector(".team-overlay");

        let innerWidth = window.innerWidth;

        window.addEventListener("resize", () => {

            innerWidth = window.innerWidth;

        })

        element.addEventListener("click", () => {

            this.Open(this.element.getAttribute("data-member"));

        });

        this.overlay.addEventListener("mousemove", event => {

            if (innerWidth <= 480 || !this.overlay.classList.contains('mousemove')) return;

            this.Update(event.clientX, event.clientY);

        });


        this.overlay.addEventListener("click", event => {

            let member = this.overlay.querySelector(`.team-overlay .team-member[data-name="${this.overlay.dataset.reference}"]`); 
            
            if (member && member.contains(member.querySelector("nav")) && member.querySelector("nav").contains(event.target)) {

                return;

            }

            // delete this.overlay.dataset.transitionend;

            // setTimeout( () => { 
                this.Close(); 
            // }, 150);

        });

        this.overlay.addEventListener("transitionend", event => {

            if (event.propertyName == "opacity") {

                if (this.overlay.dataset.reference && event.target == this.overlay) {

                    this.overlay.classList.add("mousemove");
                    this.overlay.querySelector(`.team-overlay .team-member[data-name="${this.overlay.dataset.reference}"]`).dataset.active = 1;

                }

            }
            
        });

    }

    Close() {

        delete document.body.dataset.description;
        delete this.overlay.dataset.active;
        delete this.overlay.dataset.reference;

        this.overlay.classList.remove("mousemove");

        this.overlay.querySelectorAll(".team-member").forEach(element => delete element.dataset.active);

        document.querySelectorAll(".team-overlay > img").forEach((element) => { 
            element.removeAttribute("style")
        });

        scrollLock.enableBodyScroll(this.overlay);

    }

    Update(x, y) {

        let bounds = this.overlay.getBoundingClientRect();

        x = -(bounds.left - x) / bounds.width;
        y = -(bounds.top - y) / bounds.height;

        x = Math.min(Math.max(x, 0), 1) * 100;
        y = Math.min(Math.max(y, 0), 1) * 100;

        document.querySelectorAll(".team-overlay > img").forEach((element, index) => {

            if(index === 0 ) {

                element.style.transform = `translate3d(${(-x / 10) + 5}%, ${(-y / 10) + 5}%, 0)`;

            } else {

                element.style.transform = `translate3d(${(-x / 10 * index + 1) + 5}%, ${(-y / 10 * index + 1) + 5}%, 0)`;

            }

        });

    }

    Open(reference) {

        this.overlay.dataset.reference = reference;
        this.overlay.dataset.active = 1;

        setTimeout( () => { 
            scrollLock.disableBodyScroll(this.overlay);
        }, 1000);

    }

}